import { TollRow } from "services/api/calculations/toll/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const CALCULATION_TOLL_SEARCH_COLUMNS: Column[] = [
  {
    title: "",
    field: "image",
    type: ColumnTypes.custom,
    render: (row: TollRow) => {
      return (
        <div>
          <div className="w-10 h-10 rounded-full bg-gray-200 block relative">
            <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              {row.fromCcm.toString().charAt(0).toUpperCase()}
            </span>
          </div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.toll.search.fromccm",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.fromCcm} ccm</div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.toll.search.toccm",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.toCcm} ccm</div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.toll.search.price",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.price} €</div>
        </div>
      );
    },
  },
];
